import React, {useEffect, useState, useRef, useCallback} from 'react';
import {Grid, Box, Typography, Tooltip, IconButton} from "@mui/material";
import {useDrag, DragPreviewImage} from 'react-dnd'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import {elementTypes, dragSourceType} from "../../common/staticVariables";
import {styled} from '@mui/material/styles';
import {tooltipClasses} from '@mui/material/Tooltip';
import {useDraggedItemStore} from "../../zustand/useDraggedItemStore";

import UpdateEsealDialogComponent from "./update-eseal-dialog.component";
import ChangeElementSignatureDialogComponent from './signature-dialog/change-signature-dialog.component';
import SelectProjectUserDialogComponent from './signature-dialog/select-project-user-dialog.component';


const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#6f6f6f",
    color: "#fff",
    fontSize: theme.typography.pxToRem(12), 
  },
}));

const qrcode = "data:image/png;base64,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"

const PDFDragElementBoxComponent = ({element, hasSeal, template, hasElDropped, draggedItem, setIsEsealLogoCreated, setHasSeal, template_code_queryParam,
    currentSelectedUser, setCurrentSelectedUser, setUserSignatureUpdated, userSignatureUpdated}) => {
    
    const [showSealTooltip, setShowSealTooltip] = useState(false);
    const [openUpdateEseal, setOpenUpdateEseal] = useState(false);
    const [openChangeSignature, setOpenChangeSignature] = useState(false);
    const [qrcodePreviewImg, setQrcodePreviewImg] = useState(null);
    const [openSelectUser, setOpenSelectUser] = useState(false);
    
    console.log('elementttttttttt', element)
    console.log('template aaa', template)
    console.log('has seal', hasSeal)
    console.log('element type', elementTypes)
    const {draggedElement} = useDraggedItemStore();
    console.log('drop', draggedElement)
    const businessId = template?.business_id
    const projectId = template?.project_id

    const elRef = useRef()

    const previewOptions = {
        offsetX: 0,
        offsetY: 0
    };

    // useEffect(() => {
    //     if (template) {
    //         setBusinessId()
    //     }
    // }, [JSON.stringify(template)])

    const [{ isDragging }, dragRef, preview] = useDrag(() => ({
        type: dragSourceType,
        item: {type: element?.type, value: element?.value, w: element?.width, 
            h: element?.height, userId: currentSelectedUser?.user_id, b2c_id: currentSelectedUser?.id, font_size: element.font_size},
        // options: {
        //     dropEffect: 'move',
        // },
        // previewOptions,
        end: (item, monitor) => {},
        collect: (monitor) => ({
          isDragging: monitor.isDragging(),
          handlerId: monitor.getHandlerId(),
        }),
    }), [JSON.stringify(element), JSON.stringify(currentSelectedUser), userSignatureUpdated.isUpdated])

    useEffect(() => {
        if (currentSelectedUser) {
            console.log("currentSelectedUser 234324", currentSelectedUser);
        }
    }, [currentSelectedUser])

    // useEffect(() => {
    //     var img = new Image();

    //     img.onload = function () {
    //     var canvas = document.createElement("canvas");
    //     var ctx = canvas.getContext("2d");

    //     let newWidth = 100
    //     let newHeight = 100

    //     canvas.width = newWidth;
    //     canvas.height = newHeight;

    //     ctx.drawImage(img, 0, 0, newWidth, newHeight);

    //     var resizedBase64 = canvas.toDataURL("image/png");
    //     setQrcodePreviewImg(resizedBase64);
    //     };

    //     img.src = qrcode;
    // }, [qrcode])

    // useEffect(() => {
    //     console.log("qrcodePreviewImg 111", qrcodePreviewImg);

    //     if (qrcodePreviewImg) {
    //         console.log("qrcodePreviewImg 222", qrcodePreviewImg);
    //     }
    // }, [qrcodePreviewImg])

    const boundingBox = {
        left: 0,
        top: 0,
        width: 612, // Set your bounding box width
        height: 792, // Set your bounding box height
    };

    const opacity = (isDragging) ? 0.4 : 1

    const enableCompanySeal = () => {
        
        const isUserSignatureOrField =
            element?.type === 'userSignature' ||
            element?.type === 'qrFld' ||
            element?.type === 'date' ||
            element?.type === 'txtFld';

        const hasSealOrMatchesType = hasSeal && draggedElement !== "companySeal" && element?.value !== "logo" || isUserSignatureOrField  ;
      
        // If `hasSeal` or the `element.type` matches certain values, test is set to true; otherwise, it's false
        const enable = hasSealOrMatchesType ;
      
        return enable;
    };

    const hasConfiguredUserSignature = (value) => {
        return isURL(value)
    }

    const handleMouseOver = () => { 
        let enable = !isElementEnable();
        setShowSealTooltip(enable);
    };
    
    const handleMouseOut = () => {
        setTimeout(() => {
            setShowSealTooltip(false);
        }, 3000)
    };

    const [isHovered, setIsHovered] = useState(false);

    const onMouseEnter = () => {
        setIsHovered(true)
    }
    
    const onMouseLeave = () => {
        setIsHovered(false)
    }
            
    const handleOpenUpdateEsealDialog = () => {
        setOpenUpdateEseal(true);
    }

    const handleCloseUpdateEsealDialog = () => {
        setOpenUpdateEseal(false);
        setShowSealTooltip(false);
    }

    function isURL(str) {
        // Regular expression for a simple URL pattern
        var urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
        return urlRegex.test(str);
    }

    const handleOpenChangeSignature = () => {
        console.log("handleOpenChangeSignature aa");
        // setOpenChangeSignature(true)
        setOpenSelectUser(true)
    }

    const handleCloseChangeSignature = () => {
        setOpenChangeSignature(false);
    }

    const handleCloseSelectUser = () => {
        setOpenSelectUser(false);
    }

    const isElementEnable = () => {
        let enable = true;
        if (element.type == elementTypes.userSignature) {
            let signature = currentSelectedUser?.signature
            console.log("signature hhh", signature);
            enable = hasConfiguredUserSignature(signature) 
        } 
        
        else if (element.type == elementTypes.companySeal) {
            enable = hasSeal ? false : true
        }
        console.log("hasSeal aa", hasSeal);
        console.log("enable aa", enable, element);
        return enable
    }

    return(
        <>
            <>
            <HtmlTooltip
                    arrow
                    open={showSealTooltip} 
                    placement="bottom"
                    title={
                        //  "Only one seal can be added to the document"
                        // (element?.type == elementTypes.companySeal) &&
                        (element?.type == elementTypes.companySeal || element?.type == elementTypes.userSignature) &&
                        <>
                            {
                                element?.type == elementTypes.companySeal && hasSeal ?
                                "Only one seal can be added to the document"
                                :
                                <Box>
                                    <Grid sx={{display: "flex"}}>
                                        <Typography color="inherit">
                                            {/* {
                                                element?.type == elementTypes.companySeal && element?.value == "logo" &&
                                                <>
                                                    <span>To use the e-seal, you must update the project logo.</span> &nbsp;
                                                </>
                                                
                                            } */}
                                            {
                                                element?.type == elementTypes.userSignature &&
                                                <>
                                                    <span>To use the e-signature, select user first.</span> &nbsp;
                                                </>
                                            }
                                            <span style={{cursor: "pointer", textDecoration: "underline", color: "#fff"}} onClick={(e) => {
                                                if (element?.type == elementTypes.userSignature) {
                                                    handleOpenChangeSignature()
                                                }
                                                // if (element?.type == elementTypes.companySeal) {
                                                //     handleOpenUpdateEsealDialog(e)
                                                // } else {
                                                //     handleOpenChangeSignature()
                                                // }
                                            }}>
                                                {/* {element?.type == elementTypes.companySeal && element?.value == "logo" && "Update Now"}  */}
                                                {element?.type == elementTypes.userSignature && "Select User"} 
                                            </span>
                                        </Typography>
                                    </Grid>
                                </Box>
                            }
                        </>
                }
                >
                    {/* <DragPreviewImage connect={preview} src={qrcodePreviewImg} /> */}
                    <Box 
                        ref={isElementEnable() ? dragRef : null}
                        data-testid={`box`} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}
                        sx={{height: 50, 
                            display: 'flex', 
                            alignContent: 'center',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderStyle: 'dotted !important', 
                            opacity: opacity, 
                            bgcolor: !isElementEnable() ? '#e7e7e7' : '#0178f20f',
                            border: '1px solid', 
                            borderColor: isElementEnable() ? '#bfbfbf' : '#0178f20f',
                            cursor: !isElementEnable() ? 'no-drop' : 'all-scroll',
                            p: '0px 10px 0px 0px', 
                            position: 'relative',
                            textTransform: 'none',
                            lineHeight: 1.2,
                            transition: 'all 0.1s ease 0s',
                            borderRadius: 1
                        }}  
                        onMouseEnter={(e) => onMouseEnter()} 
                        onMouseLeave={(e) => onMouseLeave()}
                    >
                        {isHovered && <DragIndicatorIcon sx={{alignSelf: 'center', color: (element?.type == elementTypes.companySeal && element?.value  == "logo") ? "rgba(24, 24, 24, 0.85)" : (element?.type == elementTypes.companySeal && hasSeal) ? "rgba(24, 24, 24, 0.85)" : "#0178f2", transition: 'opacity 0.15s ease 0s, visibility 0.15s ease 0s'}} /> }
                        
                        <Box sx={{flex: 1, pl: 1, alignSelf: 'center', transition: 'padding 0.15s ease 0s'}}>
                            <Typography sx={{fontWeight: 600, fontSize: 13, color: 'rgba(24, 24, 24, 0.85)'}}>{element?.label}</Typography>
                        </Box>
                        
                        {!isHovered && 
                            <IconButton sx={{color: (!isElementEnable() && element?.type == elementTypes.companySeal) ? '#bfbfbf' : '#0178f2', padding: 0}}>
                                {element?.icon}
                            </IconButton>
                        }
                    </Box>
                </HtmlTooltip>
            </>

            {openUpdateEseal && 
                <UpdateEsealDialogComponent openUpdateEseal={openUpdateEseal} setIsEsealLogoCreated={setIsEsealLogoCreated}
                    template={template} handleCloseDialog={handleCloseUpdateEsealDialog} setHasSeal={setHasSeal} template_code_queryParam={template_code_queryParam}
                />
            }

            {openChangeSignature &&
                <ChangeElementSignatureDialogComponent openChangeSignature={openChangeSignature} handleClose={handleCloseChangeSignature}
                    setUserSignatureUpdated={setUserSignatureUpdated} currentSelectedUserId={currentSelectedUser?.id} onSelectUser={setCurrentSelectedUser} />
            }

            {openSelectUser &&
                <SelectProjectUserDialogComponent openSelectUser={openSelectUser}
                    setOpenChangeSignature={setOpenChangeSignature}
                    handleClose={handleCloseSelectUser} businessId={businessId} projectId={projectId}
                    onSelectUser={setCurrentSelectedUser} />
            }
        </>
    )
}

export default PDFDragElementBoxComponent